const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.DefaultDescription+" "+${lambdaParameter}.DefaultTitle+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
  defaultTitle: (lambdaParameter, value) =>
    `${lambdaParameter}.DefaultTitle.Contains("${value}")`,
  defaultDescription: (lambdaParameter, value) =>
    `${lambdaParameter}.DefaultDescription.Contains("${value}")`,
  filterNotificationTagId: () => null,
  notificationTagId: (lambdaParameter, value, otherValues) =>
    otherValues.filterNotificationTagId === false
      ? null
      : `${lambdaParameter}.Tags.Any(vd=>vd.Id==${value})`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
